export default __webpack_public_path__ + "static/media/2.42b4c83c.png";